import React from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import utensilsIcon from 'assets/img/icons/utensils.svg';
import editIcon from 'assets/img/icons/edit.svg';

class NutritionPlanMenu extends React.Component {
  render() {
    return (
      <div className="page-dropdown">
        <Dropdown>
          <Dropdown.Toggle>
            <i className="fas fa-plus"></i>
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Toggle>
              <i className="fas fa-times"></i>
            </Dropdown.Toggle>
            <div className="dropdown-content">
              <Dropdown.Item
                href={`/nutrition/${this.props.planId}/client-assign`}
                className="btn btn-primary"
              >
                <i className="fas fa-user-plus"></i>
                Assign Client
              </Dropdown.Item>
              <Dropdown.Item
                href={`/nutrition/${this.props.planId}/meals/new?type=snack`}
                className="btn btn-primary"
              >
                <i className="fas fa-carrot"></i>
                Create Snack
              </Dropdown.Item>
              <Dropdown.Item
                href={`/nutrition/${this.props.planId}/meals/new?type=meal`}
                className="btn btn-primary"
              >
                <img src={utensilsIcon} /> Create Meal
              </Dropdown.Item>
              <Dropdown.Item
                href={`/nutrition/${this.props.planId}/rename`}
                className="btn btn-primary"
              >
                <img src={editIcon} /> Rename Plan
              </Dropdown.Item>
            </div>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    );
  }
}

export default NutritionPlanMenu;
